export default __webpack_public_path__ + "static/media/normal.851d0ed3.svg";